import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import permission from './permission'
import getters from './getters'
import user from './user'


const store = new Vuex.Store({
    modules: {
        permission,
        user
    },
    getters
})

export default store
